import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconAnchor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnchor"><Circle cx="12" cy="6" r="2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 9.25V16.25C12 18.5972 13.9028 20.5 16.25 20.5C18.5972 20.5 20.5 18.5972 20.5 16.25V12.5L17.5 15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 9V16.25C12 18.5972 10.0972 20.5 7.75 20.5C5.40279 20.5 3.5 18.5972 3.5 16.25V12.5L6.5 15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAnchor;
